import { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import ToastMessage from '../utils/mui/righttoptoast';
import api from '../api/api';
import { showToast } from '../reduxtoolkit/toastslice';
import { useDispatch } from 'react-redux';

const EditEntryModal = ({ setEditModal, selectedItem, fetchInventory, setLoading }) => {
  const [formData, setFormData] = useState({
    total_quantity: selectedItem.total_quantity || 0,
    quantity_per_unit: selectedItem.quantity_per_unit || 0,
    primary_lot_number: selectedItem.primary_lot_number || '',
  });
const dispatch=useDispatch()
  const [toast, setToast] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  

  const handleCloseToast = () => {
    setToast((prev) => ({ ...prev, open: false }));
  };

  const handleInputChange = (e, field) => {
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));
  };


  const handleSubmit = async () => {
    setLoading(true);
    try {
      await api.put(`/v1/${window.getPracticeId()}/inventory/${selectedItem.id}`, {
        total_quantity: Number(formData.total_quantity),
        quantity_per_unit: Number(formData.quantity_per_unit),
        primary_lot_number: formData.primary_lot_number,
      });

      // setToast({ open: true, message: 'Inventory updated successfully', severity: 'success' });
         dispatch(   showToast({
                        message: 'Inventory updated successfully',
                        severity: "success",
                      }),
                    );
      fetchInventory();
    setEditModal(false)
    } catch (error) {
      console.error(error);
      setToast({ open: true, message: 'Failed to update inventory', severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const inputClass = "border px-3 py-1.5 rounded text-sm w-full bg-[#F3F4F6]";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="relative w-full max-w-md bg-white rounded-[8.75px] border p-6">
        {/* Close Icon */}
        <button className="absolute top-3 right-3 text-gray-600 hover:text-black" onClick={() => setEditModal(false)}>
          <CloseIcon />
        </button>

        <h2 className="text-sm font-bold mb-4">Edit Inventory Item</h2>

        {/* Form Fields */}
        <div className="space-y-4">
          <div className="text-start">
            <label className="block text-xs font-medium mb-1">Total Quantity</label>
            <input
              type="number"
              className={inputClass}
              value={formData.total_quantity}
              onChange={(e) => handleInputChange(e, 'total_quantity')}
            />
          </div>

          <div className="text-start">
            <label className="block text-xs font-medium mb-1">Quantity per Unit</label>
            <input
              type="number"
              className={inputClass}
              value={formData.quantity_per_unit}
              onChange={(e) => handleInputChange(e, 'quantity_per_unit')}
            />
          </div>

          <div className="text-start">
            <label className="block text-xs font-medium mb-1">Primary Lot Number</label>
            <input
              type="text"
              className={inputClass}
              value={formData.primary_lot_number}
              onChange={(e) => handleInputChange(e, 'primary_lot_number')}
            />
          </div>
        </div>

        {/* Buttons */}
        <div className="flex justify-end gap-2 mt-6">
          <button
            onClick={() => setEditModal(false)}
            className="border px-4 py-1 rounded text-sm text-gray-700 hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="bg-black text-white px-4 py-1 rounded text-sm"
          >
            Save Changes
          </button>
        </div>

        {/* Toast Message */}
        <ToastMessage
          message={toast.message}
          severity={toast.severity}
          open={toast.open}
          handleClose={handleCloseToast}
        />
      </div>
    </div>
  );
};

export default EditEntryModal;
